import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PersonalProtectiveEquipmentFilterInput } from '../../core/interfaces/personal-protective-equipment-filter-input';

@Injectable()
export class SStatsCardPersonalProtectiveEquipmentService {

    private readonly endpointQuery = "hcm/analytics_sst/queries";

    constructor(private readonly httpClient: HttpClient) {}

    totalizerPersonalProtectiveEquipementCardsCount(filter: PersonalProtectiveEquipmentFilterInput) {
        return this.httpClient.post(`${this.endpointQuery}/employeePPETotalizerQuery`, {
            ...filter
        });
    }
}
